import { render, staticRenderFns } from "./HubHome.vue?vue&type=template&id=6ecf311a&"
import script from "./HubHome.vue?vue&type=script&lang=js&"
export * from "./HubHome.vue?vue&type=script&lang=js&"
import style0 from "./HubHome.vue?vue&type=style&index=0&id=6ecf311a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports